import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'
import Select from '../../form/Select'
import Checkbox from '../../form/Checkbox'
import Input from '../../form/Input'
import NoChartData from '../layouts/components/NoChartData'

const ChartSettingsModal = ({ store }) => {
    if (!store.activeChartData) return null

    const template = store.activeSlide?.template

    return (
        <Modal
            show={store.chartSettingsModalOpen}
            onClose={store.handleCloseChartSettingsModal}
            style={{ width: '80%' }}
        >
            <Typography type="h2">{i18n.t('powerpoint.chartSettings')}</Typography>

            <br />

            <div style={{ display: 'flex', gap: 5 }}>
                <div style={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    {store.getChart({
                        ...store.activeChartData,
                        surveyId: store.activeChart.surveyId,
                        surveyDefaultLocale: store.activeChart.surveyDefaultLocale
                            || store.activeChartData?.surveyDefaultLocale,
                        data: store.benchmarkDataForChart,
                        title: '',
                        containerSize: { height: 400, width: 450 },
                        chartType: store.activeChart?.chart || 'standardBar',
                        settings: store.activeChart.settings,
                        // kpiType: 'avg',
                    },
                    store.benchmarkDataForChart,
                    [...store.activeChart?.comparisonYears || [], store.activeChart?.year])
                        || <NoChartData question={store.activeChart} />}
                </div>

                <div>
                    {!['lmx', 'oss'].includes(template) && (
                        <>
                            <Select
                                label={i18n.t('powerpoint.chart.type')}
                                options={store.chartTypesForQuestion(store.activeChart)}
                                onBlur={(e) => {
                                    store.handleChangeChartType(e)
                                    store.activeChart?.updateChart(e)
                                }}
                                defaultValue={store.activeChart?.chart}
                            />

                            <br />

                            <Select
                                label={i18n.t('powerpoint.chart.sorting')}
                                name="sorting"
                                options={store.chartFilterOptions}
                                onBlur={store.activeChart?.updateSettings}
                                defaultValue={store.activeChart?.settings.sorting}
                            />

                            <br />

                            <Input
                                label={i18n.t('powerpoint.chart.base')}
                                type="number"
                                name="removeBaseLimit"
                                onBlur={store.activeChart?.updateSettings}
                                defaultValue={store.activeChart?.settings.removeBaseLimit}
                            />

                            <br />

                            <Checkbox
                                label={i18n.t('powerpoint.chart.zero')}
                                name="removeZero"
                                onBlur={(e) => {
                                    store.activeChart?.updateSettings(e)
                                    store.updateRemoveZeroNull(e)
                                }}
                                checked={store.activeChart?.settings.removeZero}
                            />

                            <br />

                            {store.activeChart.hasOtherOrExclusive && (
                                <>
                                    <Checkbox
                                        label={i18n.t(store.activeChart.questionTypeCode === 'CH' ? 'powerpoint.chart.lock.CH' : 'powerpoint.chart.lock')}
                                        name="locked"
                                        onBlur={(e) => {
                                            store.activeChart?.updateSettings(e)
                                        }}
                                        checked={store.activeChart?.settings.locked}
                                    />

                                    <br />
                                </>
                            )}
                            {store.activeChart.hasNonNumericValues && store.activeChart.hasNumericCodes && (
                                <Checkbox
                                    label={i18n.t('powerpoint.chart.nonNumeric')}
                                    onBlur={(e) => {
                                        store.activeChart?.updateSettings(e)
                                        store.updateRemoveZeroNull(e)
                                    }}
                                    name="excludeNonNumeric"
                                    checked={store.activeChart?.settings.excludeNonNumeric}
                                />
                            )}

                            <br />

                            {
                                ['RD', 'SD'].includes(store.activeChart.questionTypeCode)
                                && store.activeChart.hasNumericCodes
                                && ['1x2', '2x1', '2x2', '3x1'].includes(store.activeSlide.template) // support only multi question slides for now
                                && (
                                    <>
                                        <Checkbox
                                            label="Show Average"
                                            onBlur={(e) => {
                                                store.activeChart?.updateSettings(e)
                                            }}
                                            name="showAverage"
                                            checked={store.activeChart?.settings.showAverage}
                                        />

                                        <br />
                                    </>
                                )
                            }
                        </>
                    )}
                    {store.activeChart.questionTypeCode !== 'OD' && (
                        <>
                            {store.questionYears.get(store.activeChart?.surveyId) && store.questionYearsForChart?.length ? (
                                <>
                                    <Typography type="b">{i18n.t('powerpoint.labels.comparisonSurveyIds')}</Typography>
                                    {store.questionYearsForChart.map((y) => (
                                        <Checkbox
                                            label={y}
                                            value={y}
                                            checked={store.activeChart?.comparisonYears?.includes(y)}
                                            onBlur={() => store.handleToggleComparison(y)}
                                        />
                                    ))}
                                </>
                            ) : null}

                            {store.getQuestionBenchmarks(store.activeChart?.questionId, store.activeChart?.surveyId).length ? (
                                <>
                                    <Typography type="b">{i18n.t('dashboard.benchmarksTitle')}</Typography>

                                    {store.getQuestionBenchmarks(store.activeChart?.questionId, store.activeChart?.surveyId).map((y) => (
                                        <Checkbox
                                            label={y.label}
                                            value={y.value}
                                            checked={store.activeChart?.benchmark?.includes(y.value)}
                                            onBlur={() => store.handleToggleBenchmark(y.value)}
                                        />
                                    ))}
                                </>
                            ) : null}
                        </>
                    )}
                </div>
            </div>

            <ModalFooter>
                <Button
                    label={i18n.t('save')}
                    icon="fal fa-save"
                    onClick={store.handleCloseChartSettingsModal}
                    cssClass="regular primary"
                />
            </ModalFooter>
        </Modal>
    )
}

export default observer(ChartSettingsModal)
